module.exports = __webpack_public_path__ + "static/img/3.9b595b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/3.png
// module id = tNjh
// module chunks = 0